export const formatNumber = (n: number) =>
  Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatMoney = (n: number) =>
  Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Format a customer-ledger running balance with a Dr/Cr suffix instead of a
// sign. Customer = receivable/asset: a positive balance means the customer
// owes us (Dr); a negative balance means they are in credit/overpaid (Cr).
// A zero balance shows no suffix (and never "-0.00"). The number formatting
// (decimals, thousands separators) is delegated to `format` so callers can
// keep their own currency/number style.
export const formatLedgerBalance = (
  amount: number,
  format: (n: number) => string = formatNumber,
) => {
  const value = Number(amount || 0);
  const abs = Math.abs(value);
  if (abs < 0.005) return format(0);
  return value > 0 ? `${format(abs)} Dr` : `${format(abs)} Cr`;
};

export const formatDate = (input: string | number | Date) => {
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString();
};

export const formatDateTime = (input: string | number | Date) => {
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    dateStyle: "short",
    timeStyle: "short",
  });
};
